/**
 * https://github.com/tldraw/tldraw/blob/daf729d45c879d4e234d9417570149ad854f635b/packages/utils/src/lib/error.ts
 */ const annotationsByError = new WeakMap();
/**
 * Annotate an error with tags and additional data. Annotations won't overwrite existing ones.
 * Retrieve them with `getErrorAnnotations`.
 *
 * @internal
 */ export function annotateError(error, annotations) {
    if (typeof error !== "object" || error === null) return;
    let currentAnnotations = annotationsByError.get(error);
    if (!currentAnnotations) {
        currentAnnotations = {
            tags: {},
            extras: {}
        };
        annotationsByError.set(error, currentAnnotations);
    }
    if (annotations.tags) {
        currentAnnotations.tags = {
            ...currentAnnotations.tags,
            ...annotations.tags
        };
    }
    if (annotations.extras) {
        currentAnnotations.extras = {
            ...currentAnnotations.extras,
            ...annotations.extras
        };
    }
}
/** @internal */ export function getErrorAnnotations(error) {
    return annotationsByError.get(error) ?? {
        tags: {},
        extras: {}
    };
}
